import { render } from "./documentsAbout.vue?vue&type=template&id=a75e2236"
import script from "./documentsAbout.vue?vue&type=script&lang=js"
export * from "./documentsAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__